import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer>
      <a href="https://stevenrolph.com" rel="noreferrer" target="_blank">
        Steven Rolph 2023
      </a>
    </footer>
  );
};

export default Footer;
